<template>
  <v-card>
    <v-card-title class="grey--text text-subtitle-1">
      Prenotazioni
      <v-btn icon small :loading="refreshing" class="ml-2" @click="refresh">
        <v-icon>mdi-refresh</v-icon>
      </v-btn>
      <v-spacer />
      <v-text-field
        v-model="search"
        prepend-inner-icon="mdi-magnify"
        placeholder="Cerca cliente..."
        dense
        solo
        flat
        hide-details
        clearable
        style="max-width: 220px"
        class="mr-3"
      />
      <NuovaPrenotazioneDialog @creata="on_creata">
        <template v-slot:activator="{ on }">
          <v-btn outlined color="green" v-on="on">
            <v-icon class="mr-2">mdi-plus</v-icon>Nuova
          </v-btn>
        </template>
      </NuovaPrenotazioneDialog>
    </v-card-title>

    <v-tabs v-model="tab" height="36">
      <v-tab>
        Attive
        <v-chip x-small class="ml-2">{{ prenotazioni_attive.length }}</v-chip>
      </v-tab>
      <v-tab>
        Archivio
        <v-progress-circular
          v-if="archivio_loading"
          indeterminate
          size="14"
          width="2"
          class="ml-2"
        />
      </v-tab>
    </v-tabs>

    <v-card-text class="scroll pa-0">
      <v-tabs-items v-model="tab">

        <!-- Tab: Attive -->
        <v-tab-item>
          <v-divider class="mb-2" />
          <v-row class="font-weight-medium px-4" no-gutters>
            <v-col cols="1">#</v-col>
            <v-col cols="2">Cliente</v-col>
            <v-col cols="2">Data</v-col>
            <v-col cols="2">Articoli</v-col>
            <v-col cols="2">Stato</v-col>
            <v-col cols="2">Ritiro previsto</v-col>
            <v-col cols="1">Commento</v-col>
          </v-row>
          <v-divider class="mt-2 mb-1" />
          <v-row v-if="!attive_filtrate.length" justify="center" class="pt-8 pb-8 grey--text">
            Nessuna prenotazione attiva
          </v-row>
          <v-row
            v-for="p in attive_filtrate"
            :key="p._id.$oid"
            no-gutters
            align="center"
            class="px-4 py-2 riga_hover"
            style="cursor: pointer"
            @click="apri_dettaglio(p)"
          >
            <v-col cols="1" class="grey--text">{{ p.numero }}</v-col>
            <v-col cols="2">{{ p.cliente }}</v-col>
            <v-col cols="2">{{ p.data }}</v-col>
            <v-col cols="2">{{ p.articoli.length }} art · {{ tot_pezzi(p) }} pz</v-col>
            <v-col cols="2"><StatoBadge :stato="p.stato" /></v-col>
            <v-col cols="2" class="caption grey--text">{{ p.data_ritiro || "-" }}</v-col>
            <v-col cols="1" class="grey--text caption">{{ p.commento }}</v-col>
          </v-row>
        </v-tab-item>

        <!-- Tab: Archivio -->
        <v-tab-item>
          <v-divider class="mb-2" />
          <v-row class="font-weight-medium px-4" no-gutters>
            <v-col cols="1">#</v-col>
            <v-col cols="2">Cliente</v-col>
            <v-col cols="2">Data</v-col>
            <v-col cols="2">Articoli</v-col>
            <v-col cols="2">Stato</v-col>
            <v-col cols="2">Ritiro previsto</v-col>
            <v-col cols="1">Commento</v-col>
          </v-row>
          <v-divider class="mt-2 mb-1" />
          <v-row v-if="!archivio_filtrato.length" justify="center" class="pt-8 pb-8 grey--text">
            {{ archivio_loaded ? "Nessuna prenotazione in archivio" : "Caricamento..." }}
          </v-row>
          <v-row
            v-for="p in archivio_filtrato"
            :key="p._id.$oid"
            no-gutters
            align="center"
            class="px-4 py-2 riga_hover"
            style="cursor: pointer"
            @click="apri_dettaglio(p)"
          >
            <v-col cols="1" class="grey--text">{{ p.numero }}</v-col>
            <v-col cols="2">{{ p.cliente }}</v-col>
            <v-col cols="2">{{ p.data }}</v-col>
            <v-col cols="2">{{ p.articoli.length }} art · {{ tot_pezzi(p) }} pz</v-col>
            <v-col cols="2"><StatoBadge :stato="p.stato" /></v-col>
            <v-col cols="2" class="caption grey--text">{{ p.data_ritiro || "-" }}</v-col>
            <v-col cols="1" class="grey--text caption">{{ p.commento }}</v-col>
          </v-row>
        </v-tab-item>

      </v-tabs-items>
    </v-card-text>

    <!-- Dialog dettaglio -->
    <PrenotazioneDettaglio
      v-if="prenotazione_aperta"
      v-model="dialog_dettaglio"
      :prenotazione="prenotazione_aperta"
      @input="on_chiudi_dettaglio"
    />
  </v-card>
</template>

<script>
import mixin from "@/components/Prenotazioni/mixin/prenotazioni_mixin.js";
import StatoBadge from "@/components/Prenotazioni/common/StatoBadge.vue";
import NuovaPrenotazioneDialog from "./NuovaPrenotazioneDialog.vue";
import PrenotazioneDettaglio from "./PrenotazioneDettaglio.vue";

export default {
  name: "PrenotazioniDesktop",

  components: { StatoBadge, NuovaPrenotazioneDialog, PrenotazioneDettaglio },

  mixins: [mixin],

  data() {
    return {
      dialog_dettaglio: false,
      prenotazione_aperta_id: null,
      refreshing: false,
    };
  },

  computed: {
    prenotazione_aperta() {
      if (!this.prenotazione_aperta_id) return null;
      return this.$store.getters["prenotazioni/by_id"](this.prenotazione_aperta_id);
    },
  },

  methods: {
    tot_pezzi(prenotazione) {
      return prenotazione.articoli.reduce((sum, art) => sum + (art.tot ?? 0), 0);
    },

    apri_dettaglio(prenotazione) {
      this.prenotazione_aperta_id = prenotazione._id.$oid;
      this.dialog_dettaglio = true;
    },

    on_chiudi_dettaglio(val) {
      if (!val) {
        this.dialog_dettaglio = false;
        this.prenotazione_aperta_id = null;
      }
    },

    on_creata(prenotazione) {
      this.apri_dettaglio(prenotazione);
    },

    refresh() {
      this.refreshing = true;
      this.$store.dispatch("prenotazioni/fetch_attive").finally(() => {
        this.refreshing = false;
      });
    },
  },
};
</script>

<style scoped>
::-webkit-scrollbar {
  width: 2px;
}
::-webkit-scrollbar-track {
  background: #f1f1f1;
}
::-webkit-scrollbar-thumb {
  background: #bbbbbb;
}
.scroll {
  height: 400px;
  overflow-y: scroll;
}
.riga_hover:hover {
  background-color: #f5f5f5;
}
</style>
